import React from "react";
import { Button, Flex, Table, theme, Dropdown, Typography } from "antd";
import { snapshot } from "valtio";
import state from "../config/valtio/store";
import { EllipsisOutlined } from "@ant-design/icons";

const { useToken } = theme;
const { Text } = Typography;

const RenderOptions = (props) => {
  const { token } = useToken();

  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  };

  return (
    <div style={contentStyle}>
      <Flex
        vertical
        gap="small"
        style={{
          padding: 8,
        }}
      >
        {props.options.map((e) => {
          return (
            <Flex
              gap="small"
              key={e.key}
              style={{ cursor: "pointer" }}
              onClick={e.onClick}
            >
              <Text type={e.label === "Delete" ? "danger" : null}>
                {e.icon} {e.label}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </div>
  );
};

function DynamicTable(props) {
  const snap = snapshot(state);
  const columns = props.columns;
  const items = props.options;

  // Define Selected Data from Options
  const selectData = (data) => {
    props.onSelectedData(data);
  };

  if (props.useOptions === true) {
    columns.push({
      title: " ",
      key: "options",
      fixed: "right",
      width: 70,
      render: (record) => (
        <Dropdown
          placement="bottomRight"
          trigger={["click"]}
          dropdownRender={() => <RenderOptions options={items} />}
        >
          <Button
            style={{ borderRadius: 999, width: 45 }}
            onClick={() => selectData(record)}
            icon={<EllipsisOutlined />}
          ></Button>
        </Dropdown>
      ),
    });
  }

  // Select Datas
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const rowSelection = {
    selectedRowKeys: props.selectedDatas
      ? props.selectedDatas.map((e) => e.id)
      : "",
    onChange: (newSelectedRowKeys, selectedRows) => {
      props.onSelectedDatas(selectedRows);
      // console.log("selectedRowKeys changed: ", newSelectedRowKeys);
      // props.onSelectedKeys(newSelectedRowKeys);
    },
  };

  return (
    <Table
      rowSelection={props.useCheck && rowSelection}
      rowKey="id"
      columns={columns}
      dataSource={props.data}
      scroll={{
        x: columns.length > 4 ? 1000 : null,
      }}
      size="small"
      bordered
      loading={snap.LOADING}
    />
  );
}

export default DynamicTable;
